var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn button-green px-5",staticStyle:{"width":"100%"},on:{"click":function($event){return _vm.onSubmitBtn()}}},[_vm._v(" บันทึก ")])
}
var staticRenderFns = []

export { render, staticRenderFns }